<template>
    <div class="page-container" ref="pageContainer">
        <header class="page-header" :class="{ 'dark-header': isContactSectionVisible }">
            <div class="header-content">
                <img src="@/assets/logo.svg" alt="Logo" class="logo">
                <button class="contact-btn" @click="scrollToBottom">
                    联系我们
                </button>
            </div>
        </header>

        <main class="main-content" ref="mainContent">
            <div class="carousel-title">
                <h2>CitySPS®·城市服务平台</h2>
                <p>
                    <span :class="{ 'highlight-text': currentIndex === 0 }" @click="handleTitleClick(0)">CitySPS®·Demo
                    </span>\
                    <span :class="{ 'highlight-text': currentIndex === 1 }" @click="handleTitleClick(1)">CitySPS®·决策云
                    </span>\
                    <span :class="{ 'highlight-text': currentIndex === 2 }" @click="handleTitleClick(2)">城市体检评估智能平台
                    </span>\
                    <span :class="{ 'highlight-text': currentIndex === 3 }"
                        @click="handleTitleClick(3)">国土空间总体规划实施检测平台（广州市） </span>
                </p>
                <p>
                    <img src="@/assets/icons/arrow-down.svg" alt="向下箭头"
                        style="width: 20px; height: 20px; display: inline-block; vertical-align: middle;">
                    点击下方视频跳转体验
                </p>
            </div>
            <div class="carousel-wrapper" ref="carousel">
                <button class="nav-arrow nav-arrow-left" @click="goTo((currentIndex - 1 + cards.length) % cards.length)"
                    aria-label="上一项">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </button>
                <div v-for="(card, index) in cards" :key="index" class="card"
                    :class="{ 'active': currentIndex === index }" :style="getCardStyle(index)" @click="goTo(index)"
                    @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1">
                    <video v-if="shouldLoadVideo(index)" autoplay loop muted playsinline
                        :src="require(`@/assets/mov/${card.content}.mp4`)" class="card-video"></video>
                    <div class="card-info-overlay" v-show="currentIndex === index && hoverIndex === index">
                        <div class="info-content">
                            <h3>{{ card.title || card.content }}</h3>
                            <p class="description">{{ card.description || '暂无描述信息' }}</p>
                            <a v-if="card.urls" :href="card.urls" target="_blank" class="visit-btn">
                                立即体验
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" />
                                </svg>
                            </a>
                            <div v-else class="no-link-hint">
                                即将上线，敬请期待
                            </div>
                        </div>
                    </div>
                </div>
                <button class="nav-arrow nav-arrow-right" @click="goTo((currentIndex + 1) % cards.length)"
                    aria-label="下一项">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9 6L15 12L9 18" stroke="white" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </button>
            </div>
        </main>
        <section class="contact-section" ref="contactSection">
            <div class="contact-container">
                <h2 class="contact-title">联系我们</h2>
                <h3 class="contact-subtitle">如果您对 CitySPS® 产品、技术支持、合作等有任何问题和建议，都可以与我们联系</h3>
                <div class="contact-grid">
                    <div class="contact-info">
                        <h3>联系方式</h3>
                        <p><i class="icon icon-phone"></i> 电话: 0755-26035252</p>
                        <p><i class="icon icon-email"></i> 邮箱: zhaodongyi@pku.edu.cn</p>
                        <p><i class="icon icon-address"></i> 地址: 广东省深圳市南山区丽水路2099号北大校区</p>
                        <div class="map-container" ref="mapContainer"></div>
                    </div>
                    <!-- <div class="contact-form">
                        <h3>发送消息</h3>
                        <form @submit.prevent="submitForm">
                            <div class="form-group">
                                <input type="text" v-model="form.name" placeholder="您的姓名" required>
                            </div>
                            <div class="form-group">
                                <input type="email" v-model="form.email" placeholder="您的邮箱" required>
                            </div>
                            <div class="form-group">
                                <textarea v-model="form.message" placeholder="您的留言" required></textarea>
                            </div>
                            <button type="submit" class="submit-btn">发送消息</button>
                        </form>
                    </div> -->
                </div>
            </div>
        </section>
        <div class="fullscreen-bg" ref="fullscreenBg"></div>
    </div>
</template>

<script>
import arrowSvg from '@/assets/icons/location.svg';
export default {
    data() {
        return {
            currentIndex: 1,
            cardWidth: 1200,
            hoverIndex: -1,
            scrollProgress: 0,
            isContactSectionVisible: false,
            cards: [
                {
                    content: 'Demo',
                    urls: 'https://demo.cityspsindex.cn/',
                    title: 'CitySPS®·Demo',
                    description: '演示聚焦于如何通过数据可视化与空间分析等核心功能，将复杂数据转化为直观洞察，赋能城市智慧决策。'
                },
                {
                    content: '决策云',
                    urls: 'http://decisioncloud.citysps.net.cn/',
                    title: 'CitySPS®·决策云',
                    description: '基于AI的城市决策支持系统，通过智能分析与预测，赋能管理者科学决策，助力城市迈向智慧化、可持续的未来。'
                },
                {
                    content: '体检平台',
                    urls: '',
                    title: '城市体检评估智能平台',
                    description: '一站式城市健康评估系统，通过多维度大数据分析，为您提供全面、精准的城市体检报告与诊断方案。'
                },
                {
                    content: '广州大屏',
                    urls: 'http://test.guangzhou.cityspsindex.cn/screen-ind/',
                    title: '国土空间总体规划实施检测平台（广州市）',
                    description: '广州市国土空间总体规划实施监测平台，动态追踪规划指标，智能评估实施成效，保障城市发展蓝图精准落地。'
                }
            ],
            isAnimating: false,
            bottomOffsets: {
                active: '0px',
                neighbor: '-50px',
                other: '-20px'
            },
            loadedVideos: new Set(),
            form: {
                name: '',
                email: '',
                message: ''
            },
            map: null,
            marker: null
        }
    },
    computed: {
        cardHeight() {
            // 16:9比例
            return Math.round(this.cardWidth * 9 / 16)
        },
        visibleCards() {
            const prevIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length
            const nextIndex = (this.currentIndex + 1) % this.cards.length
            return [prevIndex, this.currentIndex, nextIndex]
        }
    },
    methods: {
        checkContactSectionVisibility() {
            const contactSection = this.$refs.contactSection;
            if (!contactSection) return;

            const rect = contactSection.getBoundingClientRect();
            this.isContactSectionVisible = rect.top <= 0;
        },
        scrollToBottom() {
            console.log('开始滚动到底部');

            this.$nextTick(() => {
                console.log('DOM已更新');
                console.log('文档高度:', document.body.scrollHeight);
                console.log('视口高度:', window.innerHeight);

                const pageHeight = Math.max(
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                    document.documentElement.clientHeight,
                    document.documentElement.scrollHeight,
                    document.documentElement.offsetHeight
                );

                console.log('计算的总高度:', pageHeight);

                try {
                    window.scrollTo({
                        top: pageHeight,
                        behavior: 'smooth'
                    });
                    console.log('已触发滚动');
                } catch (e) {
                    console.error('滚动错误:', e);
                }
            });
        },
        submitForm() {
            // 这里添加表单提交逻辑
            console.log('表单提交:', this.form);
            alert('感谢您的留言，我们会尽快回复您！');
            this.form = { name: '', email: '', message: '' };
        },
        handleTitleClick(index) {
            this.goTo(index);
            if (this.cards[index].urls) {
                window.open(this.cards[index].urls, '_blank');
            }
        },
        goTo(index) {
            if (this.isAnimating || this.currentIndex === index) return;

            this.isAnimating = true;
            this.currentIndex = index;

            this.loadAdjacentVideos(index);

            setTimeout(() => {
                this.isAnimating = false;
            }, 500);
        },
        loadAdjacentVideos(index) {
            const prevIndex = (index - 1 + this.cards.length) % this.cards.length;
            const nextIndex = (index + 1) % this.cards.length;

            [index, prevIndex, nextIndex].forEach(i => {
                this.loadedVideos.add(i);
            });
        },
        getCardStyle(index) {
            const isActive = this.currentIndex === index
            const isPrev = index === (this.currentIndex - 1 + this.cards.length) % this.cards.length
            const isNext = index === (this.currentIndex + 1) % this.cards.length

            let transform = ''
            let zIndex = 1
            let opacity = 0.7
            let bottom = this.bottomOffsets.other

            if (isActive) {
                transform = 'translateX(0) scale(1)'
                zIndex = 3
                opacity = 1
                bottom = this.bottomOffsets.active
            } else if (isPrev) {
                transform = 'translateX(-20%) scale(0.8)'
                zIndex = 2
                bottom = this.bottomOffsets.neighbor
            } else if (isNext) {
                transform = 'translateX(20%) scale(0.8)'
                zIndex = 2
                bottom = this.bottomOffsets.neighbor
            } else {
                transform = 'translateX(0) scale(0.6)'
                opacity = 0
                bottom = this.bottomOffsets.other
            }

            return {
                transform,
                'z-index': zIndex,
                opacity,
                width: `${this.cardWidth}px`,
                height: `${this.cardHeight}px`,
                transition: 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                left: `calc(50% - ${this.cardWidth / 2}px)`,
                bottom: bottom
            }
        },
        shouldLoadVideo(index) {
            const isActive = this.currentIndex === index;
            const isPrev = index === (this.currentIndex - 1 + this.cards.length) % this.cards.length;
            const isNext = index === (this.currentIndex + 1) % this.cards.length;
            const isLoaded = this.loadedVideos.has(index);

            if (isActive || isPrev || isNext || isLoaded) {
                this.loadedVideos.add(index);
                return true;
            }
            return false;
        },
        handleScroll() {
            const container = this.$refs.pageContainer
            const scrollTop = container.scrollTop
            const maxScroll = this.cardHeight * 0.3 // 可滚动高度为卡片高度的30%

            this.scrollProgress = Math.min(scrollTop / maxScroll, 1)

            // 调整主内容区域位置
            this.$refs.mainContent.style.transform = `translateY(${scrollTop * 0.5}px)`

            // 调整背景高度
            this.$refs.fullscreenBg.style.height = `calc(100vh + ${scrollTop}px)`
        },
        initMap() {
            this.$nextTick(async () => {
                try {
                    if (!this.$AMap) throw new Error('高德地图SDK未加载');
                    if (!this.$refs.mapContainer) throw new Error('地图容器不存在');

                    this.map = new this.$AMap.Map(this.$refs.mapContainer, {
                        zoom: 16,
                        center: [113.976704, 22.593008],
                        viewMode: "3D",
                        showBuildingBlock: true,
                        mapStyle: 'amap://styles/whitesmoke',
                    });

                    const icon = new this.$AMap.Icon({
                        size: new this.$AMap.Size(30, 30),
                        image: await this.loadSvgAsDataUrl(arrowSvg),
                        imageSize: new this.$AMap.Size(30, 30)
                    });

                    this.marker = new this.$AMap.Marker({
                        position: [113.976520, 22.593800],
                        map: this.map,
                        icon: icon
                    });
                } catch (error) {
                    console.error('地图初始化失败:', error);
                    this.$message.error('地图加载失败: ' + error.message);
                }
            });
        },

        async loadSvgAsDataUrl(svgPath) {
            if (svgPath.startsWith('data:')) return svgPath;

            if (svgPath.startsWith('http') || svgPath.startsWith('/')) {
                return svgPath;
            }

            const response = await fetch(svgPath);
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        }
    },

    mounted() {
        this.loadAdjacentVideos(this.currentIndex);
        this.$refs.pageContainer.addEventListener('scroll', this.handleScroll)

        // 初始设置
        this.$refs.mainContent.style.height = `calc(100vh - 70px + ${this.cardHeight * 0.3}px)`
        this.$refs.carousel.style.height = `${this.cardHeight}px`
        this.initMap();
        window.addEventListener('scroll', this.checkContactSectionVisibility);
    },
    beforeDestroy() {
        this.$refs.pageContainer.removeEventListener('scroll', this.handleScroll)
        if (this.marker) this.marker.setMap(null);
        if (this.map) this.map.destroy();
        this.marker = null;
        this.map = null;
        window.removeEventListener('scroll', this.checkContactSectionVisibility);
    }
}
</script>

<style scoped>
@font-face {
    font-family: 'EnFont';
    src: url('../../assets/fonts/JetBrainsMono-Bold-7.ttf') format('truetype');
    font-weight: 808;
    font-style: normal;
    font-display: swap;
    unicode-range: U+0000-00FF, U+0100-024F, U+1E00-1EFF;
}

@font-face {
    font-family: 'ZhFont_Bold';
    src: url('../../assets/fonts/HarmonyOS_Sans_SC_Bold.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    unicode-range: U+4E00-9FFF, U+3000-303F, U+FF00-FFEF;
}

@font-face {
    font-family: 'ZhFont_Thin';
    src: url('../../assets/fonts/HarmonyOS_Sans_SC_Thin.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    unicode-range: U+4E00-9FFF, U+3000-303F, U+FF00-FFEF;
}

/* 基础布局 */
.page-container {
    position: relative;
    height: auto;
    /* 改为auto以容纳新增内容 */
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
}

/* 全屏背景 */
.fullscreen-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    background: radial-gradient(circle at center top,
            #0a2a3a 0%,
            #0e2f4f 20%,
            #1a3f7a 40%,
            #324a9a 60%,
            #5a3f9a 80%,
            #6a2a8a 100%);
    background-attachment: fixed;
    animation: gradientShift 5000ms ease infinite;
    background-size: 200% 200%;
    opacity: 0.9;
    transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: -1;
}

.fullscreen-bg::before,
.fullscreen-bg::after {
    content: "";
    position: absolute;
    bottom: -20%;
    height: 150%;
    opacity: 1;
    width: 100%;
    background: radial-gradient(circle at center bottom,
            rgb(69, 69, 69) 0%,
            rgb(127, 127, 127) 15%,
            rgb(255, 255, 255) 30%,
            transparent 70%);
    pointer-events: none;
    mix-blend-mode: overlay;
}

.fullscreen-bg::before {
    left: 50%;
    transform: translateX(-50%);
}

.fullscreen-bg::after {
    left: 50%;
    transform: translateX(-50%);
}

/* 头部导航 */
.page-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 15px 20px;
    background: rgba(255, 255, 255, 0);
    z-index: 100;
    transition: all 0.3s ease;
}

.page-header::before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    height: 10px;
    background: rgba(255, 255, 255, 0);
    filter: blur(5px);
    z-index: -1;
}

.page-header.dark-header {
    background: rgba(0, 0, 0, 0);
}

.page-header.dark-header .logo {
    filter: brightness(0) invert(0);
}

.page-header.dark-header .contact-btn {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1580px;
    margin: 0 auto;
}

.logo {
    height: 55px;
    filter: brightness(0) invert(1);
    transition: filter 0.3s ease;
}

.logo:hover {
    filter: brightness(0) invert(1) drop-shadow(0 0 6px rgba(255, 255, 255, 0.448));
}

.contact-btn {
    padding: 10px 24px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: white;
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow:
        0 4px 6px rgba(0, 0, 0, 0.05),
        0 1px 0 0 rgba(255, 255, 255, 0.15) inset,
        0 -1px 0 0 rgba(0, 0, 0, 0.1) inset;
    overflow: hidden;
    position: relative;
}

.contact-btn::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.1) 50%,
            rgba(255, 255, 255, 0) 100%);
    transform: rotate(30deg);
    transition: all 0.6s ease;
}

.contact-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.3));
}

.contact-btn:hover::before {
    left: 100%;
}

/* 主内容区域 */
.main-content {
    margin-top: 85px;
    position: relative;
    min-height: 100vh;
    padding-bottom: 30vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 轮播标题 */
.carousel-title {
    font-family: 'EnFont', 'ZhFont_Bold';
    position: absolute;
    top: 7%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: #ffffff;
    z-index: 2;
    width: 100%;
    max-width: 1200px;
    pointer-events: none;
}

.carousel-title h2 {
    font-size: 4.5em;
    margin-bottom: 1.5rem;
    font-weight: 600;
    text-shadow:
        0 0 6px rgba(255, 255, 255, 0.31),
        0 0 26px rgba(255, 255, 255, 0.31);
}

.carousel-title p {
    font-size: 1.2rem;
    color: #a1a1a1;
    font-family: 'ZhFont_Thin', 'EnFont';
    pointer-events: auto;
}

.carousel-title p span {
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 2px 8px;
    border-radius: 4px;
}

.carousel-title p span:hover {
    background: rgba(255, 255, 255, 0.1);
}

.highlight-text {
    font-size: 1.3rem;
    color: white;
    text-shadow:
        0 0 8px rgba(255, 255, 255, 0.5),
        0 0 16px rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    font-weight: bold;
    display: inline-block;
    transform: translateY(0px);
}

/* 轮播容器 */
.carousel-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: auto;
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 1;
    transform-origin: bottom center;
}

/* 轮播卡片 */
.card {
    position: absolute;
    background-color: rgba(255, 255, 255, 0);
    border-radius: 10px;
    box-shadow: 0 -4px 20px rgba(155, 155, 155, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    will-change: transform, opacity;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    overflow: hidden;
    transition:
        transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        opacity 0.3s ease,
        bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    z-index: 1;
}

.card.active {
    z-index: 3;
    box-shadow: 0 -4px 20px rgba(210, 210, 210, 0.7);
}

.card-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    border-radius: 8px 8px 0 0;
    transition: object-position 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.page-container.scrolled .card-video {
    object-position: center center;
}

/* 导航箭头 */
.nav-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-20%);
    width: 56px;
    height: 56px;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 4;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow:
        0 4px 6px rgba(0, 0, 0, 0.05),
        0 1px 0 0 rgba(255, 255, 255, 0.15) inset,
        0 -1px 0 0 rgba(0, 0, 0, 0.1) inset;
    overflow: hidden;
}

.nav-arrow::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.1) 50%,
            rgba(255, 255, 255, 0) 100%);
    transform: rotate(30deg);
    transition: all 0.6s ease;
}

.nav-arrow:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-50%) scale(1.08);
    box-shadow:
        0 8px 12px rgba(0, 0, 0, 0.1),
        0 2px 0 0 rgba(255, 255, 255, 0.2) inset,
        0 -2px 0 0 rgba(0, 0, 0, 0.15) inset;
}

.nav-arrow:hover::before {
    left: 100%;
}

.nav-arrow svg {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    position: relative;
    z-index: 1;
}

.nav-arrow path {
    stroke: rgba(255, 255, 255, 0.9);
}

.nav-arrow-left {
    left: 6%;
}

.nav-arrow-right {
    right: 6%;
}

/* 卡片信息覆盖层 */
.card-info-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top,
            rgba(0, 0, 0, 0.85) 0%,
            rgba(0, 0, 0, 0.7) 50%,
            rgba(0, 0, 0, 0.4) 100%);
    backdrop-filter: blur(4px);
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: flex-end;
    padding: 30px;
    opacity: 0;
    animation: fadeIn 0.3s ease-out forwards;
    z-index: 10;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.info-content {
    width: 100%;
    color: white;
    transform: translateY(20px);
    transition: transform 0.3s ease 0.1s;
}

.card-info-overlay:hover .info-content {
    transform: translateY(0);
}

.info-content h3 {
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 2.2rem;
    margin-bottom: 1rem;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.info-content .description {
    font-family: 'ZhFont_Thin', sans-serif;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    opacity: 0.9;
    max-width: 80%;
}

.visit-btn {
    display: inline-flex;
    align-items: center;
    padding: 12px 24px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 30px;
    color: white;
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 1rem;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.visit-btn svg {
    margin-left: 8px;
    transition: transform 0.3s ease;
}

.visit-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.visit-btn:hover svg {
    transform: translateX(3px);
}

.no-link-hint {
    display: inline-block;
    padding: 12px 24px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px dashed rgba(255, 255, 255, 0.3);
    border-radius: 30px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 1rem;
}

.contact-section {
    position: relative;
    width: 100%;
    min-height: 980px;
    margin-top: 151px;
    margin-bottom: 0;
    background: rgb(255, 255, 255);
    backdrop-filter: blur(10px);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 40px;
}

.contact-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.contact-title {
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 3.5rem;
    color: rgb(0, 0, 0);
    text-align: center;
    margin-bottom: 10px;
    margin-top: 32px;
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.179);
}

.contact-subtitle {
    font-family: 'ZhFont_Thin', sans-serif;
    font-size: 1.2rem;
    color: rgb(0, 0, 0);
    text-align: center;
    margin-bottom: 20px;
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.179);
}

.contact-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0px;
}

.contact-info {
    background: rgb(238, 238, 238);
    padding: 40px;
    border-radius: 20px;
    backdrop-filter: blur(10px);
    border: 1px solid rgb(255, 255, 255);
}

.contact-info h3 {
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 2rem;
    color: rgb(0, 0, 0);
    margin-bottom: 30px;
}

.contact-info p {
    font-family: 'ZhFont_Thin', sans-serif;
    font-size: 1.2rem;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.icon {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.icon-phone {
    background-image: url('../../assets/icons/phone.svg');
}

.icon-email {
    background-image: url('../../assets/icons/email.svg');
}

.icon-address {
    background-image: url('../../assets/icons/map.svg');
}

.contact-form {
    background: rgb(238, 238, 238);
    padding: 40px;
    border-radius: 20px;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.contact-form h3 {
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 2rem;
    color: rgb(0, 0, 0);
    margin-bottom: 30px;
}

.form-group {
    margin-bottom: 25px;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 15px;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    color: rgb(0, 0, 0);
    font-family: 'ZhFont_Thin', sans-serif;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.15);
}

.form-group textarea {
    height: 150px;
    resize: none;
}

.submit-btn {
    padding: 15px 30px;
    background: linear-gradient(135deg, rgba(90, 63, 154, 0.8) 0%, rgba(42, 74, 154, 0.8) 100%);
    border: none;
    border-radius: 8px;
    color: white;
    font-family: 'ZhFont_Bold', sans-serif;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.submit-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* 背景动画 */
@keyframes gradientShift {
    0% {
        background-position: 0% 0%;
    }

    50% {
        background-position: 100% 100%;
    }

    100% {
        background-position: 0% 0%;
    }
}

/* 滚动状态样式 */
.page-container.scrolled .carousel-title {
    opacity: 0.8;
    transform: translateX(-50%) scale(0.95);
    transition: all 0.3s ease;
}

.page-container.scrolled .card {
    box-shadow: 0 -4px 30px rgba(155, 155, 155, 0.8);
}

.map-container {
    width: 100%;
    height: 200px;
    margin-top: 20px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #f0f0f0;
}

.custom-marker {
    width: 30px;
    height: 30px;
    background: #4b4852;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(0, 0, 0);
    font-size: 16px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.icon-location {
    background-image: url('../../assets/icons/map.svg');
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}
</style>


// WEBPACK FOOTER //
// src/page/firstPage/firstPage.vue